module.exports = __webpack_public_path__ + "static/img/4.4bffba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/4.png
// module id = WlMq
// module chunks = 0